<script setup lang="ts">
import {Icon} from '#components'
import {resolveMediaProps} from '~/utils/relations'
import type {Populated} from '~/types/populated'
import type {AboutUs} from '~/types/legacy'

const props = defineProps<{
  data: Exclude<Populated<AboutUs>['ourTeam']['people'], null | undefined>
}>()

const components = {
  facebook: h(Icon, {name: 'fa6-brands:facebook'}),
  linkedin: h(Icon, {name: 'fa6-brands:linkedin'}),
  instagram: h(Icon, {name: 'fa6-brands:instagram'}),
  twitter: h(Icon, {name: 'simple-icons:x'}),
}
</script>

<template>
  <div>
    <div class="flex max-w-screen-sm flex-wrap items-center justify-center gap-4">
      <div
        v-for="member of data"
        :key="member.name"
        class="flex w-[148px] flex-col items-center justify-center p-4 md:w-[202px]"
      >
        <div class="relative h-32 w-32 rounded-lg">
          <NuxtImg v-bind="resolveMediaProps(member.image)" class="rounded-lg" />
          <div class="absolute inset-0 rounded-lg bg-[#2aaea359] mix-blend-overlay bordershadow-image" />
        </div>

        <Paragraph as="h2" size="normal" weight="medium" align="center" class="mb-1 mt-4 !text-gray-950">
          {{ member.name }}
        </Paragraph>

        <Paragraph as="p" size="normal" weight="normal" align="center" class="!text-gray-400">
          {{ member.role }}
        </Paragraph>

        <Paragraph
          v-if="member.yearsOfExperience"
          as="p"
          size="small"
          weight="normal"
          align="center"
          class="mb-2 !text-gray-400"
        >
          {{ `${member.yearsOfExperience} ${$t('team.years_experience')}` }}
        </Paragraph>

        <div class="flex items-center justify-center gap-1">
          <a v-for="social of member.socials" :key="social.platform" :href="social.url" target="_blank">
            <component :is="components[social.platform as keyof typeof components]" class="h-5 w-5 !text-gray-500" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
